export enum Pages{

    customerDetailsPage="customerDetailsPage",
  
    prospectTrackerPage="prospectTracker",
  
    productTrackerPage="productTracker",
  
    applicationTrackerPage="applicationTracker",
  
    relationshipTrackerPage="relationshipTracker",
  
    oppurtunityTrackerPage="oppurtunityTracker",

    underwritingTrackerPage="underwritingTracker",
  
    caseManagementTrackerPage="caseTracker",
  
    caseManagementDetailsPage="caseManagementDetailsPage",
  
    landingPage="landing",

    DOCU_SIGN_INIT = "docuSignInit",

    DOCU_SIGN_REDIRECT = "docuSign"
  
  }
  
   
  
  export enum actionAuthorization{
  
    createLead="createlead",
  
    prospectingMenuItem="prospectingMenuItem",
  
    trackerMenuItem="trackerMenuItem",

    oppurtuntiesMenuItem="oppurtunityMenuItem",

    underwritingMenuItem="underwritingMenuItem",
  
    relationshipsMenuItem="relationshipsMenuItem",
  
    messagesMenuItems="messagesMenuItems",
  
    settingMenuItems="settingsMenuItem",
  
    caseMangementMenuItems="caseMangementMenuItems",

    applicationTrackerMenuItem="applicationTrackerMenuItem",
    
    adminSettingsMenuItems = "adminSettingsMenuItems",

   dashboardMenuItems = "dashboardMenuItems",
  
    //cutomer details page
  
      // details tab
  
    viewInternalNotes="viewInternalNotes",
  
    editInternalNotes="editInternalNotes",
  
    addInternalNotes="addInternalNotes",
  
    deleteInternalNotes="deleteInternalNotes",
  
   
  
    viewCustomerMessages="viewCustomerMessages",
  
    accsssOpenMC="accsssOpenMC",
  
    accessQuickReply="accessQuickReply",
  
   
  
    viewDocuments="viewDocumentsTab",
  
   
  
    viewInteractionHistory="viewInteractionHistory",
    viewCustomerActivities="viewCustomerActivities",
  
   
  
    createActionItem="createActionItems",
  
    editActionItem="editActionItems",
  
    viewActionItem="viewActionItem",
  
   
  
    viewProductsTab="viewProductsTab",
  
    editProductsTile="editProductsTab",
  
   
  
    viewAccountsTab="viewAccountsTab",
  
   
  
    // status tab
  
   
  
    accessViewApplication="viewApplication",
  
    accessResendApplication="accessResendApplication",
  
    createNDA="createNDA",
  
    accessSignatureRequiredResendButton="accessSignatureRequiredResendButton",
  
    accessSignatureRequiredVoidButton="accessSignatureRequiredVoidButton",
  
    accessSignatureRequiredEditButton="accessSignatureRequiredEditButton",
  
    accessSignatureRequiredViewButton="accessSignatureRequiredViewButton",
  
   
  
    editLeadInformationStatusTab="editLeadInformationStatusTab",
  
   
  
    accessAccountStatusDropDownView="accessAccountStatusDropDownView",
  
    accessAccountStatusView="accessAccountStatusView",
  
    accessAccountStatusProgressView="accessAccountStatusProgressView",
  
   
  
    editCompanyInfo="CompanyinfoEdit",
  
    viewCompanyInfo="viewCompanyInfo",

    viewApplicationProgress = "viewApplicationProgress",

    viewReviewProgress = 'viewReviewProgress',
  
   
  
    //Rolodex
  
    viewRolodex="viewRolodex",
  
    editRolodex="editRolodex",
  
    createContactRolodex="createContactRolodex",
  
   
  
    //customerDetailsPage Upper part
  
   
  
     accessAddLabel="accessAddLabel",
  
     editLabel="editLabel",
  
     deleteLabel="deleteLabel",
  
   
  
     accessReassign="accessReassign",
  
   
  
   // landing Page
  
   
  
    viewMyTodos="viewMyTodos",
    editMyTodos="editMyTodos",
  
    assignMyTodos="assignMyTodos",
  
   
  
    createManualTodos="createManualTodos",
  
    editManualTodos="editManualTodos",
  
   
  
    viewStatusTiles="viewStatusTiles",
  
   
  
    viewInfocus="viewInfocus",
  
   
  
    viewMessageCenter="viewMessageCenter",
  
    replyMessageCenter="replyMessageCenter",
  
   
  
    createQucikLinks="createQuickLinks",
  
    deleteQuickLinks="deleteQuickLinks",
  
    editQuickLinks="editQuickLinks",
  
    viewQuickLinks="viewQuickLinks",
  
   
  
    viewNotifications="viewNotifications"
  
   
  
  }